<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <core-table
          ref="maintenanceTable"
          :config="config"
          title="Maintenance message list"
          upsertMaxWidth="1000"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import config from "./config_index.js";

export default {
  data() {
    return {
      config,
    };
  },
  created() {},
  beforeDestroy() {},
  methods: {},
};
</script>
